import React from 'react';
import { Star, Check } from 'lucide-react';
import { ImageCarousel } from './ImageCarousel';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/8U6jwPDsPXzUm5bwg9GMyE/ChatGPT_Image_24_ene_2026,_10_43_52_p.m..png', 'https://cdn.magicpatterns.com/uploads/vw9mEeJ7KRTDDvmCYnhDyb/ChatGPT_Image_24_ene_2026,_12_41_35_a.m..png', 'https://cdn.magicpatterns.com/uploads/oAVMLSeX3x7Yt9QGT67eZR/ChatGPT_Image_24_ene_2026,_10_45_55_p.m..png', 'https://cdn.magicpatterns.com/uploads/xaqLvvaU2RydaLARxW973P/ChatGPT_Image_24_ene_2026,_10_49_39_p.m..png'];
const CHECKLIST = ['Técnicas simples y rápidas', 'Funciona aunque tengas poco tiempo', 'Sin meditaciones complicadas', 'Ayuda a reducir ansiedad y estrés', 'Recupera claridad mental y tranquilidad'];
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#FAF5EF] pt-8 pb-16 lg:pt-16 lg:pb-24" data-id="element-120">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-121">
        {/* Emotional Opening */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-122">
          <h1 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4 leading-tight" data-id="element-123">
            Calma la ansiedad y silencia tu mente en solo 5 minutos al día
          </h1>
          <p className="text-xl md:text-2xl text-[#C06B6B] font-medium mb-4" data-id="element-124">
            Descubre el método práctico que ayuda a reducir pensamientos
            excesivos, bajar el estrés y recuperar tranquilidad mental
            rápidamente, incluso si sientes que tu mente nunca descansa.
          </p>
          <p className="text-base text-gray-500 mb-8" data-id="element-125">
            Ebook digital · 5 minutos al día · Resultados desde el primer uso
          </p>

          {/* Symptom bullets — compact */}
          <div className="flex flex-wrap justify-center gap-2 max-w-2xl mx-auto mb-8" data-id="element-126">
            {CHECKLIST.map((s, i) => <div key={i} className="flex items-center gap-2 bg-white rounded-lg px-3 py-2 border border-[#C06B6B]/10" data-id="element-127">
                <Check className="h-4 w-4 text-[#C06B6B] flex-shrink-0" data-id="element-128" />
                <span className="text-sm text-gray-700" data-id="element-129">{s}</span>
              </div>)}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-start" data-id="element-130">
          {/* Left Column: Carousel */}
          <div className="relative" data-id="element-131">
            <span className="absolute top-4 left-4 z-10 rounded-full bg-[#C06B6B] px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-white shadow-sm" data-id="element-132">
              Popular
            </span>
            <ImageCarousel images={IMAGES} data-id="element-133" />
          </div>

          {/* Right Column: Product Info */}
          <div className="flex flex-col justify-center" data-id="element-134">
            {/* Reviews */}
            <div className="flex items-center gap-2 mb-4" data-id="element-135">
              <div className="flex text-[#C4973B]" data-id="element-136">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-4 w-4 fill-current" data-id="element-137" />)}
              </div>
              <span className="text-sm font-medium text-gray-600" data-id="element-138">
                4.9/5 · Más de 2,400 mujeres ya lo utilizan
              </span>
            </div>

            {/* Title */}
            <h2 className="text-4xl font-serif font-bold text-gray-900 sm:text-5xl mb-2" data-id="element-139">
              Calma tu Mente en 5 Minutos
            </h2>
            <p className="text-xl text-[#C06B6B] font-medium mb-6" data-id="element-140">
              Ebook Digital · Método Práctico
            </p>

            {/* Price */}
            <div className="flex items-center gap-4 mb-3 p-4 bg-white/50 rounded-xl border border-[#C06B6B]/20 w-fit" data-id="element-141">
              <div data-id="element-142">
                <p className="text-sm text-gray-400 line-through" data-id="element-143">Antes: $75</p>
                <p className="text-3xl font-bold text-gray-900" data-id="element-144">
                  Hoy: $11.99{' '}
                  <span className="text-base font-medium text-gray-500" data-id="element-145">
                    pago único
                  </span>
                </p>
              </div>
            </div>
            <p className="text-xs text-[#C06B6B] font-semibold mb-1" data-id="element-146">
              Ahorra $63 hoy (84% de descuento)
            </p>
            <p className="text-xs text-gray-500 mb-3" data-id="element-147">
              📲 Acceso inmediato después del pago · Disponible desde tu
              teléfono
            </p>
            <div className="mb-6 flex items-start gap-2 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-id="element-148">
              <span className="text-base flex-shrink-0" data-id="element-149">⏳</span>
              <p className="text-xs text-red-700 font-medium leading-snug" data-id="element-150">
                Oferta de lanzamiento disponible por tiempo limitado. El precio
                puede cambiar en cualquier momento.
              </p>
            </div>

            {/* Bonuses — promoted as part of the offer */}
            <div className="mb-5" data-id="element-151">
              <p className="text-xs font-bold uppercase tracking-wider text-[#C4973B] mb-3" data-id="element-152">
                🎁 Incluye 2 Bonos GRATIS
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-153">
                <div className="bg-white rounded-xl border-2 border-[#C4973B]/30 p-4 shadow-sm relative" data-id="element-154">
                  <span className="absolute -top-2 -right-2 bg-[#C4973B] text-white text-[10px] font-bold uppercase px-2 py-0.5 rounded-full" data-id="element-155">
                    Gratis
                  </span>
                  <div className="text-2xl mb-2" data-id="element-156">🎁</div>
                  <p className="font-bold text-sm text-gray-900 leading-tight" data-id="element-157">
                    Respiraciones que Calman
                  </p>
                  <p className="text-xs text-[#C06B6B] font-medium mt-1" data-id="element-158">
                    60 segundos
                  </p>
                </div>
                <div className="bg-white rounded-xl border-2 border-[#C4973B]/30 p-4 shadow-sm relative" data-id="element-159">
                  <span className="absolute -top-2 -right-2 bg-[#C4973B] text-white text-[10px] font-bold uppercase px-2 py-0.5 rounded-full" data-id="element-160">
                    Gratis
                  </span>
                  <div className="text-2xl mb-2" data-id="element-161">🌙</div>
                  <p className="font-bold text-sm text-gray-900 leading-tight" data-id="element-162">
                    Rutinas Nocturnas
                  </p>
                  <p className="text-xs text-[#C06B6B] font-medium mt-1" data-id="element-163">
                    para Dormir Mejor
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto rounded-full bg-[#C4973B] px-8 py-4 text-lg font-bold text-white shadow-md hover:bg-[#B08632] hover:shadow-lg transition-all transform hover:-translate-y-0.5 mb-3 text-center inline-block" data-id="element-164">
              👉 QUIERO MI EBOOK + 2 BONOS GRATIS
            </a>

            <p className="text-xs text-gray-600 font-medium mb-6 leading-relaxed" data-id="element-165">
              ✓ Descarga inmediata · Pago seguro · PDF digital · Acceso desde
              celular
            </p>

            {/* Guarantee Badge */}
            <div className="mt-2 flex items-center gap-3 bg-rose-50 border border-rose-200 rounded-xl px-4 py-3 w-fit" data-id="element-166">
              <span className="text-sm font-semibold text-rose-800" data-id="element-167">
                🛡️ Garantía total de 7 días
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}